jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});


jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});

const searchInput = document.querySelector('[data-input-search]');
const placeholderTexts = [
    "Turbotechnics S280",
    "TRS Performance Stage 3",
    "Ford Fiesta ST MK7 Brake Pads",
    "Motul RBF660 Brake Fluid",
    "Royal Purple 5w30"
];

let placeholderIndex = 0;
let charIndex = 0;
let typingForward = true;

// Ensure the placeholder starts empty
searchInput.placeholder = "";

function typePlaceholder() {
    if (typingForward) {
        // Typing forward
        searchInput.placeholder = placeholderTexts[placeholderIndex].substring(0, charIndex);
        charIndex++;

        if (charIndex > placeholderTexts[placeholderIndex].length) {
            typingForward = false;
            setTimeout(typePlaceholder, 1200); // Pause before deleting
        } else {
            setTimeout(typePlaceholder, 50); // Faster typing speed
        }
    } else {
        // Deleting backward
        searchInput.placeholder = placeholderTexts[placeholderIndex].substring(0, charIndex);
        charIndex--;

        if (charIndex < 0) {
            typingForward = true;
            placeholderIndex = (placeholderIndex + 1) % placeholderTexts.length; // Move to next text
            setTimeout(typePlaceholder, 300); // Shorter pause before typing next text
        } else {
            setTimeout(typePlaceholder, 30); // Faster deleting speed
        }
    }
}

// Start typing effect after a 1-second delay to avoid flashing full text
setTimeout(() => {
    typePlaceholder();
}, 1000);
